<template>
  <div class="numOfBusiness">
    <p class="title">交易笔数</p>
    <div id="numOfBusiness_chart"></div>
    <div class="bottom_box">
      <img class="robot" src="../../../assets/image/workPlatform/robot.png" alt="">
      <div class="rightBox">
        <p class="msg" :title="resultData.businessAnalysis">经营分析：{{resultData.businessAnalysis}}</p>
        <div class="btn_box">
          <span class="btn"  @click="sendReport" v-if="btnJurisdiction.isSendCoupon">去发券</span>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import echarts from 'echarts'
import { getNumOfBusiness } from '@/api/businessAnalysis'

export default {
  props: {
    btnJurisdiction: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      echartsDom: null,
      gasId: '',
      resultData: {}
    }
  },
  methods: {
    init (gasId) {
      this.gasId = gasId
      this.getNumOfBusiness()
    },
    // 单位
    geUnit (num, unit) {
      let number = num || num === 0 ? (num >= 1000000 ? Math.round(num/100)/100 : num) : '-'
      let txt = unit || '元'
      return {
        num: number,
        unit: num >= 1000000 ? '万' + txt : txt
      }
    },
    drawLine () {
      this.echartsDom = null
      this.echartsDom = echarts.init(document.getElementById('numOfBusiness_chart'))
      let data = this.resultData.seriesDto.map(item => {
        return {
          ...item,
          type: 'bar',
        }
      })
      this.echartsDom.setOption({
        color: ['#3377FF', '#FFAC52'],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'dashed'
            },
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: (params) => {
            let relVal = params[0].axisValue 
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].marker + params[i].seriesName + '： ' + (this.geUnit(params[i].value).num) + (this.geUnit(params[i].value, '人').unit)
              }
              return relVal
          },
          textStyle: {
            color: '#606266'
          }
        },
        legend: {
          data: ['近30日用户数', '上30日用户数'],
          bottom: '0px',
          itemHeight: 10,
          itemWidth: 10
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          splitLine: {
            lineStyle: {
              type:'dashed',
              color:'#EAEAEA'
            }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}人'
          }
        },
        yAxis: {
          type: 'category',
          data: this.resultData.axis,
          nameTextStyle: {
            color:'#666'
          },
          axisLine: {
            lineStyle: {
              color:'#EAEAEA'
            }
          },
          axisLabel: {
            color:'#666'
          },
          axisTick: {
            show: false
          }
        },
        series: data
      })
    },
    async getNumOfBusiness () {
      try {
        const { code, result } = await getNumOfBusiness({ gasId: this.gasId })
        if (code !== 200) return
        this.resultData = result
        this.drawLine()
      } catch (error) {
        console.log(error)
      }
    },
    sendReport () {
      this.$track.clickEvent('经营分析-去发券按钮', 1655798953)
      this.$router.push({path: '/vipMarket/vipDraw'})
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../style/index.less');
</style>